import React from 'react';
import { useOddData } from '../common/OddWrapper';
import { classIf } from '../data/utils';

export default function Odd(props) {
    const odd = props.data;

    const [desc, selected, addBet] = useOddData(odd);

    return (
        <>
            {odd.value ?
                <div className={"odd" + classIf(selected, 'selected')} onClick={addBet}>
                    <span>{odd.value}</span>
                </div>
                :
                <div className="odd">
                    <i className="fa fa-lock" />
                </div>
            }
        </>
    );
}
